import { Transform } from 'class-transformer'
import { DateTime } from 'luxon'

export function DateTransformFromMillis() {
  return Transform(({ value }: any) => value && DateTime.fromMillis(value), {
    toClassOnly: true,
  })
}
